import type { AiChatMessage } from "@productlane/lib/src/ai"

export type AgentSetupCardKind = "linear_issue" | "agent_instructions"

export interface AgentSetupCardPatch {
	status: NonNullable<AiChatMessage["linearIssueProposal"]>["status"]
	errorMessage?: string
	created?: { identifier: string; url: string }
}

const CARD_KEY = {
	linear_issue: "linearIssueProposal",
	agent_instructions: "agentInstructionsProposal",
} as const

export function applyAgentSetupCardPatch(
	messages: AiChatMessage[],
	messageId: string,
	kind: AgentSetupCardKind,
	patch: Partial<AgentSetupCardPatch>,
): AiChatMessage[] {
	const key = CARD_KEY[kind]
	return messages.map((m) => {
		const card = m[key]
		if (m.id !== messageId || !card) return m
		return { ...m, [key]: { ...card, ...patch } }
	})
}

// A refusal the user can fix by asking again is guidance, not a failure.
const GUIDANCE_CODES = new Set([
	"NOT_FOUND",
	"FORBIDDEN",
	"CONFLICT",
	"PRECONDITION_FAILED",
	"BAD_REQUEST",
])

export function agentSetupFailureToast(
	kind: AgentSetupCardKind,
	error: unknown,
): { type: "info" | "error"; title: string; description?: string } {
	const reason =
		error instanceof Error && error.message
			? error.message
			: "Try again in a moment."
	const code = (error as { data?: { code?: string } } | null)?.data?.code
	if (code && GUIDANCE_CODES.has(code)) return { type: "info", title: reason }
	return {
		type: "error",
		title:
			kind === "linear_issue"
				? "Linear did not create the issue"
				: "The agent instructions did not save",
		description: reason,
	}
}
